import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'ng-diversions-complete',
  templateUrl: './diversions-complete.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DiversionsCompleteDialog {
  @Input() loading!: boolean;
  @Output() completeDiversion = new EventEmitter<string>();
  fg: UntypedFormGroup = new UntypedFormGroup({
    reason: new UntypedFormControl('', [Validators.required, Validators.maxLength(783)])
  });

  constructor() { }
}
